//useAuth.ts
// 
import { createContext, useContext, useEffect, useState } from "react";

export interface AuthUser {
  user_id:    string;
  email:      string;
  full_name:  string;
  is_admin:   boolean;
  last_login: string | null;
  entitlements?: {
    modules: string[];
    tools:   string[];
    apps:    "*" | string[];
    deployment_modules?: string[];
    entitled_modules?: string[];
  };
}

interface AuthCtx {
  user:    AuthUser | null;
  loading: boolean;
  setUser: (u: AuthUser | null) => void;
  logout:  () => void;
}

export const AuthContext = createContext<AuthCtx>({
  user:    null,
  loading: true,
  setUser: () => {},
  logout:  () => {},
});

export function useAuth() {
  return useContext(AuthContext);
}